

import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Box, CircularProgress } from "@mui/material";
import { decryptToken } from "../../../Utlis/Encryption";
import { BASE_URL } from "../../../components/BaseUrl";
import TruncatedCell from "../../../components/TruncatedCell.js";

const localizer = momentLocalizer(moment);

const CalendarView = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;

  // 🔹 Fetch worker tasks
  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}/task-management/worker/tasks?page=1&page_size=50&show_history=true`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await res.json();
        console.log("✅ Worker tasks API:", data);

        if (!data.error) {
          const mappedEvents = data.data.tasks.map((task) => ({
            id: task.id,
            title: task.title,
            start: new Date(task.start_at),
            end: new Date(task.end_at),
            status: task.status, // assigned, in_progress, completed, etc.
            worker: task.assigned_by_name || "—",
            location: task.location_address,
          }));

          setEvents(mappedEvents);
        }
      } catch (err) {
        console.error("❌ Error fetching tasks:", err);
      } finally {
        setLoading(false);
      }
    };

    if (token) fetchTasks();
  }, [token]);

  // 🔹 Color coding by status
  const eventStyleGetter = (event) => {
      let backgroundColor = "#3174ad"; // default
    if (event.status === "completed") backgroundColor = "green";
    if (event.status === "assigned") backgroundColor = "blue";
    if (event.status === "cancelled") backgroundColor = "red";
    if (event.status === "in_progress") backgroundColor = "orange";
    if (event.status === "not_done") backgroundColor = "black";

    return {
      style: {
        backgroundColor,
        color: "white",
        borderRadius: "6px",
        border: "0px",
        display: "block",
        paddingLeft: "4px",
      },
    };
  };

  return (
    <Box sx={{ height: "80vh", p: 2, background: "#fff", borderRadius: "8px" }}>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Calendar
          localizer={localizer}
          events={events}
          defaultView="month"
          views={["day", "week", "month"]}
          startAccessor="start"
          endAccessor="end"
          style={{ height: "100%" }}
          eventPropGetter={eventStyleGetter}
          components={{
            event: ({ event }) => (
              <span>
                             <TruncatedCell text={event.title} sx={{color:"white"}}/> <br />

                <br />
                <small>{event.status}</small>
              </span>
            ),
          }}
        />
      )}
    </Box>
  );
};

export default CalendarView;
